import DealAlertHandler from './components/DealAlertHandler'
export default DealAlertHandler
